'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';

/**
 * Keeps a scrollable container pinned to the bottom whenever any of `deps`
 * change (typically: the message list and the stream status).
 *
 * Lives in a hook because that's the guide's accepted escape hatch for a
 * raw `useEffect` side-effect — the component using this gets a clean API
 * (`<div ref={ref}>…`) instead of an ambient effect leaking into render.
 */
export function useAutoScrollToBottom(deps) {
  const $ = _c(1);
  const ref = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const el = ref.current;
      if (!el) {
        return;
      }
      el.scrollTop = el.scrollHeight;
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(t0, deps);
  return ref;
}